import { StyledText } from '@app/collections/dynamic-form/elements'
import { Button, Col, Description, DescriptionItem, If, Notification, Row, Spacer, Spin, Text } from '@app/components'
import { InfoCircleOutlined } from '@app/components/icons'
import { IStore } from '@app/redux'
import { auth, Axios, createTweet, db } from '@app/services'
import { SummaryPropsBuy3 } from '@app/types'
import { toCurrency, toSmallerCurrency } from '@app/utils'
import axios from 'axios'
import { doc, onSnapshot } from 'firebase/firestore'
import { ETHEREUM_MAINNET_ID, useWalletChainId } from 'libs/ethereum/useWalletChainId'
import { useBuyBalance } from 'libs/services/hooks/useCSTBalance'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount } from 'wagmi'

import { AddDiscountDrawer } from '../drawers'
import { StyledCard } from './elements'

export const Summary: React.FC<SummaryPropsBuy3> = ({
  purchaseData: { pay, receive },
  //refresh,
  fee,
  //cst,
  //setCst,
  balance,
  //setCoastBalance,
  // transactionRefresh is bumped via setTransactionRefresh only
  setTransactionRefresh,
  queueLength,
}) => {
  //const { user } = useSelector((state: IStore) => state)
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false)
  //const [loading, setLoading] = useState(false)
  //const [pending, setPending] = useState(0)
  //const [percent, setPercent] = useState(0)
  //const [transactionId, setTransactionId] = useState('')

  //const [startToken, setStartToken] = useState('')
  //const [endToken, setEndToken] = useState('')
  //const [startAmount, setStartAmount] = useState(0)
  const [response, setResponse] = useState(null)
  //const [callData, setCallData] = useState('')
  const [apiLoading, setAPILoading] = useState(false)
  //const [pending, setPending] = useState(0)
  //const [percent, setPercent] = useState(0)
  const [generationLoading, setGenerationLoading] = useState(false)
  //const [pendingResponse, setPendingResponse] = useState('')
  const [priceChecked, setPriceChecked] = useState(false)
  const [priceCheckLoading, setPriceCheckLoading] = useState(false)
  const [transactionId, setTransactionId] = useState<string | undefined>(undefined)
  //const [buyBalance, setBuyBalance] = useState(0)

  const { address } = useAccount()
  const chainId = useWalletChainId()
  const buyBalanceHook = useBuyBalance(false)
  const BuyBalance = process.env.NEXT_PUBLIC_ENV == 'development' ? { value: 100000000 } : buyBalanceHook
  const [videoOpen, setVideoOpen] = useState(false)
  const notifiedSendStatus = useRef<string | null>(null)

  // const mint = useMint()

  const getAddress = {
    PLS: 'PLS',
    WAIT: '0x26179a4d4b58b4456f28d19507546596c9058ee5',
    HEX: '0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39',
    PLSX: '0x95B303987A60C71504D99Aa1b13B4DA07b0790ab',
    INC: '0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d',
    PHLPv2: '0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b',
    TIDE: '0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf',
    GLORY: '0x37D16BabDce0427e63233b3d9be149B31ac2E6f8',
    CST: '0x600136dA8cc6D1Ea07449514604dc4ab7098dB82',
    //PRVX change here
    PRVX: '0xF6f8Db0aBa00007681F8fAF16A0FDa1c9B030b11',
  }

  const { user } = useSelector((state: IStore) => state)
  const isEhex = receive.type === 'eHEX'
  const usePlsV2 = !isEhex && process.env.NEXT_PUBLIC_PLS_BUY_ENGINE === 'true'

  const handleApiCall = async () => {
    try {
      if (receive.type === 'eHEX') {
        setAPILoading(true)
        receive.setAmount('Loading')
        const authorization = await auth.currentUser.getIdToken()
        const result: any = await Axios.post(
          '/api/ethereum/quote',
          { usd: pay.amount },
          { headers: { Authorization: authorization } },
        )
        setResponse(result)
        receive.setAmount(result.data.hexAmount)
        setPriceChecked(true)
        return result
      }

      if (usePlsV2) {
        setAPILoading(true)
        receive.setAmount('Loading')
        const authorization = await auth.currentUser.getIdToken()
        const result: any = await Axios.post(
          '/api/pulsechain/quote',
          { usd: pay.amount, token: receive.type, fee },
          { headers: { Authorization: authorization } },
        )
        setResponse(result)
        receive.setAmount(result.data.tokenAmount)
        setPriceChecked(true)
        return result
      }

      let outToken: string

      switch (receive.type) {
        case 'PLS':
          outToken = 'PLS'
          break
        case 'WAIT':
          outToken = '0x26179a4d4b58b4456f28d19507546596c9058ee5'
          break
        case 'HEX':
          outToken = '0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39'
          break
        case 'PLSX':
          outToken = '0x95B303987A60C71504D99Aa1b13B4DA07b0790ab'
          break
        case 'INC':
          outToken = '0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d'
          break
        case 'PHLPv2':
          outToken = '0x7eE9946b082E197652Bf5d4Bdc2A034DBfF4121b'
          break
        case 'TIDE':
          outToken = '0xdedBCc8D9458B2556375680FbA297C6aCa6c7DCf'
          break
        case 'GLORY':
          outToken = '0x37D16BabDce0427e63233b3d9be149B31ac2E6f8'
          break
        case 'CST':
          outToken = '0x600136dA8cc6D1Ea07449514604dc4ab7098dB82'
          break
        //PRVX change here
        case 'PRVX':
          outToken = '0xF6f8Db0aBa00007681F8fAF16A0FDa1c9B030b11'
          break
        default:
          outToken = 'PLS'
          break
      }
      setAPILoading(true)
      receive.setAmount('Loading')

      //eslint-disable-next-line no-console
      console.log('amount: ', pay.amount * ((100 - fee - 0.25) / 100) * 10 ** 6)

      // const result: any = await axios.get(
      //   `https://api.piteas.io/quote?tokenInAddress=0x600136dA8cc6D1Ea07449514604dc4ab7098dB82&tokenInChainId=369&tokenOutAddress=${outToken}&tokenOutChainId=369&amount=${
      //     pay.amount * ((100 - fee - 0.25) / 100) * 10 ** 6
      //   }&allowedSlippage=2.00`,
      // )
      const result: any = await axios.get(
        `/api/piteas/quote?tokenInAddress=0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07&tokenInChainId=369&tokenOutAddress=${outToken}&tokenOutChainId=369&amount=${
          pay.amount * ((100 - fee - 0.25) / 100) * 10 ** 6
        }&allowedSlippage=2.00`,
      )
      setResponse(result)
      receive.setAmount(result.data.destAmount / 10 ** result.data.destToken.decimals)
      setPriceChecked(true)

      return response
    } catch (error: any) {
      const message = error?.response?.data?.error || error?.message || 'Unable to get price'
      setResponse(message)
      Notification({ message, type: 'error' })
      receive.setAmount(0)
      //setCallData('')
    } finally {
      setAPILoading(false)
    }
  }

  /*useEffect(() => {
    swapAddressBalance(setBuyBalance)
  }, [fee, pay.amount, receive.amount])*/

  useEffect(() => {
    setPriceChecked(false)
    setPriceCheckLoading(false)
    receive.setAmount(0)
  }, [fee, pay.amount, receive.type])

  const checkPrice = async () => {
    setPriceCheckLoading(true)
    if (receive.type && pay.amount != 0 && pay.amount) {
      await handleApiCall()
    } else if (pay.amount == 0 || !pay.amount) {
      receive.setAmount(0)
    }
    setPriceCheckLoading(false)
  }

  const createTransaction = async () => {
    try {
      setGenerationLoading(true)
      // Fire immediately so the start toast is not tied to the long send HTTP.
      if (isEhex || usePlsV2) {
        Notification({ message: 'Buy Initiated', type: 'success' })
      }

      const data = {
        entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
        amount: pay.amount,
        expectedAmount: receive.amount,
        token: getAddress[receive.type],
        fee: fee,
        wallet: address,
      }

      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }

      const path = isEhex ? '/api/ethereum/buy' : usePlsV2 ? '/api/pulsechain/buy' : '/api/north-one/buy'
      const payload = isEhex
        ? {
          entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
          amount: pay.amount,
          wallet: address,
        }
        : usePlsV2
          ? {
            entityId: user.selectedEntityName ? user.selectedEntityIdentityId : null,
            amount: pay.amount,
            wallet: address,
            token: receive.type,
            fee,
          }
          : data
      const res: any = await Axios.post(path, payload, {
        headers,
        timeout: isEhex || usePlsV2 ? 120000 : undefined,
      })
      const id = res.data.buyId || res.data.transactionId
      notifiedSendStatus.current = null
      setTransactionId(id)
      if (!isEhex && !usePlsV2) {
        Notification({ message: 'Buy Initiated', type: 'success' })
      }
      // Show Pending row as soon as we have an id — send completes via Firestore listener.
      setTransactionRefresh((v) => Number(v) + 1)

      if (pay.amount >= 1000) {
        await createTweet(auth, { type: 'swaps', amount: receive.amount, address: address, token: receive.type })
      }
    } catch (error: any) {
      const message = error?.response?.data?.error || error?.message || 'Buy failed'
      Notification({ message, type: 'error' })
    } finally {
      setResponse(null)
      setGenerationLoading(false)
      pay.setAmount(0)
    }
  }

  useEffect(() => {
    if (transactionId !== undefined && transactionId !== '') {
      const unsub = onSnapshot(doc(db, 'Transactions', transactionId), (snap) => {
        if (!snap.exists) return
        const row = snap.data()
        if (row.engine === 'pls-v2' || row.engine === 'eth-v2') {
          const status = row.sendStatus
          const sendFailed = status === 'failed'
          const sendDone = !sendFailed && Boolean(row.sendTxHash || row.hash || status === 'confirmed')
          const effectiveStatus = sendFailed ? 'failed' : sendDone ? 'confirmed' : status
          if (effectiveStatus === notifiedSendStatus.current) return

          if (effectiveStatus === 'confirmed') {
            notifiedSendStatus.current = 'confirmed'
            Notification({ message: 'Send Completed Successfully', type: 'success' })
            setTransactionRefresh((v) => Number(v) + 1)
          } else if (effectiveStatus === 'failed') {
            notifiedSendStatus.current = 'failed'
            Notification({ message: 'Transaction failed to process', type: 'error' })
            setTransactionRefresh((v) => Number(v) + 1)
          } else if (status === 'queued_for_inventory') {
            notifiedSendStatus.current = status
            Notification({ message: 'Queued — waiting for inventory', type: 'success' })
            setTransactionRefresh((v) => Number(v) + 1)
          } else if (status === 'queued' || status === 'claimed' || status === 'sending') {
            // Keep the Pending row in sync; toast already fired at buy start.
            notifiedSendStatus.current = status
            setTransactionRefresh((v) => Number(v) + 1)
          }
          return
        }

        const buyStep = row.buyStep
        switch (buyStep) {
          case 0:
            if (row.status == 'Failed') {
              Notification({ message: 'Transaction failed to process', type: 'error' })
            }
          case 3:
            if (row.buyStep == 3) {
              Notification({ message: 'Swap Completed Successfully', type: 'success' })
            }
            setTransactionRefresh(3)
            break
          case 4:
            Notification({ message: 'Send Beginning', type: 'success' })
            setTransactionRefresh(4)
            break
          case 5:
            Notification({ message: 'Send Completed Successfully', type: 'success' })
            setTransactionRefresh(5)
            break
          case 6:
            Notification({ message: 'Swap Failed, retrying', type: 'error' })
            setTransactionRefresh(6)
            break
          case 7:
            Notification({ message: 'Send Failed, retrying', type: 'error' })
            setTransactionRefresh(7)
            break
        }
      })

      return () => unsub()
    }
  }, [transactionId])

  const topLabelItemStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 'bold',
  }

  const topDescriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '18px',
  }

  const descriptionItemStyle: React.CSSProperties = {
    justifyContent: 'end',
  }

  const labelFeeBoldItemStyle: React.CSSProperties = {
    marginLeft: '16px',
    fontSize: '14px',
  }

  const descFeeBoldItemStyle: React.CSSProperties = {
    justifyContent: 'end',
    fontSize: '14px',
  }

  const summaryDesc = (
    <Row align="middle" gutter={0}>
      <Text style={{ fontSize: '24px' }}>Buy Summary</Text>
      <Button type="text" size="small" onClick={() => setVideoOpen(true)}>
        <InfoCircleOutlined size={20} />
      </Button>
    </Row>
  )

  /*const feeLink = (
    <Button
      type="link"
      style={{ padding: 0, fontSize: '14px' }}
      size="small"
      onClick={() => setDiscountDrawerOpen(true)}
    >
      Fee ({fee}%)
    </Button>
  )*/

  return (
    <>
      <StyledCard>
        <Description title={summaryDesc} column={1}>
          <DescriptionItem label={'Total Cost'} labelStyle={topLabelItemStyle} contentStyle={topDescriptionItemStyle}>
            {`${toCurrency(pay.amount, true)} ${pay.type}`}
          </DescriptionItem>
          <DescriptionItem label={'Total Buy'} labelStyle={topLabelItemStyle} contentStyle={topDescriptionItemStyle}>
            {apiLoading ? <Spin /> : `~${toCurrency(receive.amount, false)} ${receive.type}`}
          </DescriptionItem>
          {isEhex && Number(receive.amount) > 0 && (
            <DescriptionItem label={'Price'} contentStyle={descriptionItemStyle}>
              {`${toSmallerCurrency(pay.amount / Number(receive.amount), true)} / eHEX`}
            </DescriptionItem>
          )}
          {chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) && address != undefined && (
            <DescriptionItem label={'Total Fees'} contentStyle={descriptionItemStyle}>
              {`${toCurrency(pay.amount * (fee / 100), true)} ${pay.type}`}
            </DescriptionItem>
          )}

          <DescriptionItem
            label={`Fees (${fee}%)`}
            labelStyle={labelFeeBoldItemStyle}
            contentStyle={descFeeBoldItemStyle}
          >
            {`${toCurrency(pay.amount * (fee / 100), true)} ${pay.type}`}
          </DescriptionItem>

          <DescriptionItem label={'Wallet'} contentStyle={descriptionItemStyle}>
            {address != undefined ? address.slice(0, 4) + '...' + address.slice(-4) : 'Connect Wallet'}
          </DescriptionItem>
          <DescriptionItem label={'Remaining Balance'} contentStyle={descriptionItemStyle}>
            {toCurrency(balance - pay.amount, true)}
          </DescriptionItem>
          <DescriptionItem label={'Current Queue Length'} contentStyle={descriptionItemStyle}>
            {queueLength}
          </DescriptionItem>
          <DescriptionItem label={'Processing in'} contentStyle={descriptionItemStyle}>
            {`~${queueLength * 4 + 4} Minutes`}
          </DescriptionItem>
        </Description>

        <Spacer />
        <Row>
          <Col span={24}>
            {!priceChecked && (
              <Button
                block
                disabled={
                  address == undefined ||
                  !pay.amount ||
                  pay.amount <= 0.1 ||
                  pay.amount > balance ||
                  (isEhex && chainId != ETHEREUM_MAINNET_ID)
                }
                onClick={checkPrice}
                loading={priceCheckLoading}
              >
                {address == undefined ? 'Connect Wallet' : 'Check Price'}
              </Button>
            )}
            {priceChecked && (
              <Button
                block
                disabled={
                  address == undefined ||
                  !pay.amount ||
                  apiLoading ||
                  pay.amount <= 0.1 ||
                  pay.amount > balance ||
                  (isEhex && chainId != ETHEREUM_MAINNET_ID) ||
                  (!isEhex && pay.amount - pay.amount * (fee / 100) > Number(BuyBalance.value) / 10 ** 6) ||
                  receive.amount == 0
                }
                onClick={createTransaction}
                loading={generationLoading}
              >
                {!isEhex && pay.amount - pay.amount * (fee / 100) > Number(BuyBalance.value) / 10 ** 6
                  ? 'Insufficient Liquidity'
                  : `Buy ${toCurrency(receive.amount, false)} ${receive.type}`}
              </Button>
            )}
          </Col>
        </Row>
        <If condition={!isEhex && chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN)}>
          <>
            <Spacer value={20} />
            <StyledText>Connect to PulseChain Mainnet to Buy Pulsechain Assets</StyledText>
          </>
        </If>
        <If condition={isEhex && chainId != ETHEREUM_MAINNET_ID}>
          <>
            <Spacer value={20} />
            <StyledText>Connect to Ethereum Mainnet to buy HEX (eHEX)</StyledText>
          </>
        </If>
        {/* <Button block type="link" onClick={test}>yup</Button> */}
      </StyledCard>

      <AddDiscountDrawer open={discountDrawerOpen} toggleOpen={() => setDiscountDrawerOpen(!discountDrawerOpen)} />

      {videoOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
          onClick={() => setVideoOpen(false)}
        >
          <div
            style={{
              position: 'relative',
              width: '80%',
              maxWidth: '800px',
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setVideoOpen(false)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                background: 'transparent',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
              }}
            >
              ×
            </button>
            <iframe
              width="100%"
              height="450"
              src="https://www.youtube.com/embed/o3fTxoZ1b7Q?si=SAAzTU8wG1g4EAYd"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}

      {/***<BuyPendingModal
        pending={pending}
        setPending={setPending}
        toggleOpen={() => {
          return true
        }}
        percent={percent}
        setPercent={setPercent}
        transactionId={pendingResponse}
        token={receive.type}
      />***/}
    </>
  )
}
